import React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Icons from "@src/components/Icons"

export function getCurrentAppliedQuantityPromotion(cartData) {
  if (!cartData?.quantity_promotion_info?.promotion) return null
  return cartData.quantity_promotion_info.promotion
}

const QuantityDiscountAlert = ({ cartData, products, t }) => {
  if (!cartData || !cartData.quantity_promotion_info?.promotion) return null

  const currentPromotion = cartData.quantity_promotion_info.promotion
  const appliedTier = currentPromotion?.applied_tier
  const discountPercent =
    appliedTier?.discount_percent ?? currentPromotion?.discount_percent ?? 0
  const nextTier = currentPromotion?.next_tier

  return (
    <>
      {currentPromotion && (
        <Box
          sx={{
            background: "#FFF9F9",
            borderRadius: "8px",
            padding: 2.5,
            marginBottom: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            boxShadow: "0 2px 8px 0 rgba(255, 215, 64, 0.10)",
            minHeight: 64,
            marginTop: 1
          }}
        >
          <Typography
            variant="body1"
            color="#DF0000"
            fontWeight={700}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            {t("quantity_discount_alert", { percent: discountPercent })}{" "}
          </Typography>
          {nextTier &&
            (() => {
              const remaining =
                nextTier.min_quantity -
                (currentPromotion.eligible_quantity ?? 0)
              if (remaining <= 0) return null
              return (
                <Typography variant="body2" color="#DF0000" mt={1}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t("cart.next_quantity_discount_note", {
                        discount_percent: nextTier.discount_percent,
                        num: remaining
                      })
                    }}
                  />
                </Typography>
              )
            })()}
        </Box>
      )}
    </>
  )
}

export default QuantityDiscountAlert
